import { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { loadBootstrap, unloadBootstrap } from "../utils/loadBootstrap";

export default function AdminLayout() {
  useLayoutEffect(() => {
    loadBootstrap();
    return () => unloadBootstrap();
  }, []);

  return (
    <div className="admin-layout">
      <Sidebar />

      <div className="main-content">
        <Topbar />
        <main className="p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
